<template>
  <el-form
    v-loading.fullscreen.lock="loading"
    :model="form"
    @submit.native.prevent="onSubmit"
  >
    <el-form-item :error="error('example')">
      <input
        v-model="form.example"
        placeholder="Example"
        @change="change('example')"
      >
    </el-form-item>
  </el-form>
</template>

<script>
  import { AjaxDataProvider } from '@fps/vue-toolkit/dist/services/http/ajax-data-provider';

  export default {
    props: {
      res: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        // Resource name to process
        resource: false,
        // Resource name to process
        autoload: false,
        // Resource identifier name
        idProperty: 'id',
        // Requested data
        item: {},
        // Resource options
        resourceOptions: {},
        // Provider instance used to manipulate the resource
        provider: false,
        // Loading flag that triggers full screen loading lock
        loading: false,
        // All validation errors
        errors: {},
        // Form data container
        form: {
        },
      };
    },
    watch: {
      res(res) {
        this.resource = res;
        this.initProvider();
      },
    },
    mounted() {
      if (this.res) {
        this.resource = this.res;
      }

      if (this.resource) {
        this.initProvider();
      }

      this.$watch(`$route.params.${this.idProperty}`, () => { this.onRouteLoaded(); });

      this.onRouteLoaded();
    },
    methods: {
      // Triggered on form submit
      onSubmit() {
      },
      // Called on handling validation errors
      onFormError(response) {
        this.loading = false;
        if (response.status === 422) {
          // console.log(response.data.errors);
          this.errors = response.data.errors;
        }
      },
      // Getter for validation errror
      error(index) {
        return this.errors[index] === undefined ? '' : this.errors[index][0];
      },
      // Change detection clear error
      change(index) {
        this.errors[index] = undefined;
      },
      // Called when route params are loaded, uses idProperty to load the resource
      onRouteLoaded() {
        if (this.autoload && this.provider && this.$route.params[this.idProperty]) {
          this.loading = true;
          this.provider.item(this.$route.params[this.idProperty])
            .then(({ data }) => {
              this.item = data;
              this.loading = false;
            });
        } else {
          this.item = {};
        }
      },
      initProvider() {
        this.provider = new AjaxDataProvider(this.resource, this.resourceOptions);
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Core/ResourcePage.vue